import React from 'react';
import { Spinner } from 'react-bootstrap';
import './Loader.css';

const Loader = () => {
  return (
    <div className="load">
      <hr />
      <hr />
      <hr />
      <hr />
    </div>
  );
};

export default Loader;
